import { HelpOutline } from '@mui/icons-material';
import { Card, CardContent, CardHeader, Link, Tooltip, Typography } from '@mui/material';
import { t } from 'i18next';
import { ComponentLoader } from '../../components/ComponentLoader';
import { InventoryCategory } from '../models/InventoryCategory';
import { ChartContent } from './ChartContent';
import { ChartContent as ChartContentBlankState } from './blankStates/ChartContent';
import { TitleChart as TitleChartSkeleton } from './skeletons/TitleChart';

type Props = {
  title: string;
  helpText?: string;
  category: InventoryCategory | null;
  loading: boolean;
  initialLoad: boolean;
  linkTo?: string;
  disableAnimation?: boolean;
};

const cardHeaderStyle = {
  borderBottom: 1,
  borderColor: 'divider',
  pt: 1.25,
  px: 2.5,
  pb: 0.625,
} as const;

export const TitleChart = ({ category, title, helpText, loading, initialLoad, linkTo, disableAnimation = false }: Props) => {
  if (category === null && initialLoad) {
    return <TitleChartSkeleton />;
  }

  const headerTitle = (
    <Typography variant="overline" sx={{ fontWeight: 500, color: 'text.secondary' }}>
      {linkTo ? (
        <Link href={linkTo} color={'inherit'} target="_blank">
          {title}
        </Link>
      ) : (
        title
      )}
      {helpText && (
        <Tooltip title={helpText}>
          <HelpOutline fontSize={'inherit'} sx={{ verticalAlign: 'middle', ml: 1, mb: 0.375 }} />
        </Tooltip>
      )}
    </Typography>
  );
  return (
    <Card elevation={2}>
      <ComponentLoader loading={loading}>
        <CardHeader sx={cardHeaderStyle} title={headerTitle} />
        <CardContent sx={{ pt: 1 }}>
          {!category ? (
            <ChartContentBlankState title={title} />
          ) : (
            <ChartContent title={t('a11y.organization.dashboard.chartTitle', { chartName: title })} category={category} disableAnimation={disableAnimation} />
          )}
        </CardContent>
      </ComponentLoader>
    </Card>
  );
};
